import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Client from '../views/Client.vue';
import Service from '../views/Service.vue';
import Report from '../views/Report.vue';
import Login from '../views/Login.vue';
import PublicHome from '../views/PublicHome.vue';
import Providers from '../views/Providers.vue';
import Roles from '../views/Roles.vue';
import PaymentMethods from '../views/PaymentMethods.vue';
import Inventory from '../views/Inventory.vue';
import Financeiro from '../views/Financeiro.vue';

/** True when app is running as installed PWA (standalone/fullscreen/minimal-ui or iOS standalone). */
function isPwaStandalone() {
  if (typeof window === 'undefined') return false;
  const mq = window.matchMedia('(display-mode: standalone)');
  if (mq && mq.matches) return true;
  if (window.matchMedia('(display-mode: fullscreen)').matches) return true;
  if (window.matchMedia('(display-mode: minimal-ui)').matches) return true;
  return !!window.navigator.standalone;
}

const routes = [
  {
    path: '/',
    name: 'PublicHome',
    component: PublicHome
  },
  {
    path: '/admin/',
    name: 'Home',
    component: Home
  },
  {
    path: '/admin/clientes',
    name: 'Client',
    component: Client
  },
  {
    path: '/admin/servicos',
    name: 'Services',
    component: Service
  },
  {
    path: '/admin/equipe',
    name: 'Providers',
    component: Providers
  },
  {
    path: '/admin/relatorio',
    name: 'Report',
    component: Report
  },
  {
    path: '/admin/perfis',
    name: 'Roles',
    component: Roles
  },
  {
    path: '/admin/formas-pagamento',
    name: 'PaymentMethods',
    component: PaymentMethods
  },
  {
    path: '/admin/estoque',
    name: 'Inventory',
    component: Inventory
  },
  {
    path: '/admin/financeiro',
    name: 'Financeiro',
    component: Financeiro
  },
  {
    path: '/admin/entrar',
    name: 'Login',
    component: Login
  }
];

const router = createRouter({
  history: createWebHistory('/'),
  routes
});

// Installed PWA: always open admin, never public home
router.beforeEach((to) => {
  if (isPwaStandalone() && to.path === '/') {
    return { path: '/admin/', replace: true };
  }
});

export default router;
